import * as actionTypes from '../../actionTypes';

// utilities
import _ from 'lodash';

// initial state
export const initialState = {};


export default function skillsReducer(state = initialState, {type, skills}) {
  switch (type) {
    case actionTypes.UPDATE_APPLICANT :
      // need to use assign to handle logout
      const mergedSkills = _.merge({}, state, skills);
      const newSkills = _.reduce(mergedSkills, (result, category, key) => {
        const skillList = _.filter(category, s => s.deleted !== Symbol.for('_deleted_'));
        _.forEach(skillList, s => _.setWith(result, `${key}.${String(s.name)}`, s, Object), {});
        return result;
      }, {});

      return newSkills;

    case actionTypes.CLEAR_APPLICANT :
    case actionTypes.LOG_OUT :
      return {};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./shared/redux/reducers/skills/index.js